
import './style.scss';


interface IIframeProps {
    src: string;
    title?: string;
    className?: string;
}


const Iframe: React.FC<IIframeProps> = ({
    src,
    title = '',
    className = '',
}) => {
    return (
        <iframe
            src={src}
            title={title ?? ''}
            className={`iframe-default ${className}`}
        />
    );
}

export default Iframe;